export const IT_MALE_NAMES = [
  "Abbondanzio",
  "Abbondio",
  "Abebe",
  "Abele",
  "Abelino",
  "Abramo",
  "Accursio",
  "Achille",
  "Adalberto",
  "Adalgiso",
  "Adamo",
  "Adelchi",
  "Adelfo",
  "Adelmo",
  "Ademaro",
  "Adeodato",
  "Adolfo",
  "Adone",
  "Adriano",
  "Adrio",
  "Agapito",
  "Agatino",
  "Agenore",
  "Agostino",
  "Agricola",
  "Agrippino",
  "Aiace",
  "Aimone",
  "Aladino",
  "Alamanno",
  "Alarico",
  "Albano",
  "Alberico",
  "Alberto",
  "Albino",
  "Alboino",
  "Alceo",
  "Alceste",
  "Alcide",
  "Alcino",
  "Aldebrando",
  "Aldo",
  "Aleandro",
  "Aleardo",
  "Alemanno",
  "Alessandro",
  "Alessio",
  "Alfeo",
  "Alfio",
  "Alfonso",
  "Alfredo",
  "Algiso",
  "Alighiero",
  "Aliprando",
  "Alvise",
  "Amadeo",
  "Amadeus",
  "Amando",
  "Amedeo",
  "Amerigo",
  "Amico",
  "Amilcare",
  "Amintore",
  "Amini",
  "Amleto",
  "Anacleto",
  "Andrea",
  "Angelo",
  "Aniceto",
  "Aniello",
  "Annibale",
  "Ansaldo",
  "Anselmo",
  "Anteo",
  "Antero",
  "Antonello",
  "Antonino",
  "Antonio",
  "Appio",
  "Arcadio",
  "Arcibaldo",
  "Ardito",
  "Ardo",
  "Arduino",
  "Argimiro",
  "Argo",
  "Arialdo",
  "Ariberto",
  "Ariele",
  "Ariosto",
  "Aris",
  "Aristide",
  "Aristo",
  "Aristotele",
  "Armando",
  "Arminio",
  "Arnaldo",
  "Aroldo",
  "Arrigo",
  "Arsenio",
  "Artemio",
  "Arturo",
  "Ascanio",
  "Asdrubale",
  "Attila",
  "Attilio",
  "Audace",
  "Augusto",
  "Aureliano",
  "Aurelio",
  "Auro",
  "Ausilio",
  "Avelino",
  "Aventino",
  "Azeglio",
  "Azzio",
  "Baccio",
  "Baldassarre",
  "Baldo",
  "Baldomero",
  "Bartolomeo",
  "Basilio",
  "Bassiano",
  "Bastiano",
  "Battista",
  "Beato",
  "Bellino",
  "Benedetto",
  "Beniamino",
  "Benigno",
  "Benito",
  "Benvenuto",
  "Berengario",
  "Bernardo",
  "Berto",
  "Bertoldo",
  "Biagio",
  "Bindo",
  "Bino",
  "Boccaccio",
  "Bonaventura",
  "Bonifacio",
  "Bonaldo",
  "Brancaleone",
  "Brando",
  "Bruno",
  "Bruto",
  "Calcedonio",
  "Callisto",
  "Calogero",
  "Camillo",
  "Candido",
  "Cantidio",
  "Canziano",
  "Carlo",
  "Carmelo",
  "Carmine",
  "Caronte",
  "Casimiro",
  "Cassiano",
  "Cassio",
  "Cataldo",
  "Catullo",
  "Cecco",
  "Cecilio",
  "Celeste",
  "Celestino",
  "Celio",
  "Celso",
  "Cesare",
  "Cesario",
  "Cicerone",
  "Cino",
  "Cipriano",
  "Ciriaco",
  "Cirillo",
  "Ciro",
  "Claudio",
  "Cleandro",
  "Clemente",
  "Clementino",
  "Cleto",
  "Clodomiro",
  "Clodoveo",
  "Cola",
  "Colosso",
  "Coluccio",
  "Concetto",
  "Coriolano",
  "Cornelio",
  "Corrado",
  "Cosimo",
  "Costante",
  "Costantino",
  "Costanzo",
  "Crescenzo",
  "Crespino",
  "Crispino",
  "Cristaldo",
  "Cristiano",
  "Cristoforo",
  "Crocefisso",
  "Curzio",
  "Cusmano",
  "Custode",
  "Dagoberto",
  "Dalmazio",
  "Dalmiro",
  "Damaso",
  "Damiano",
  "Daniele",
  "Danilo",
  "Dante",
  "Dario",
  "Davide",
  "Davino",
  "Decimo",
  "Delfino",
  "Demetrio",
  "Democrito",
  "Deodato",
  "Desiderato",
  "Desiderio",
  "Diamante",
  "Diego",
  "Dino",
  "Diocleziano",
  "Diodoro",
  "Diogene",
  "Diomede",
  "Dione",
  "Dionigi",
  "Dionisio",
  "Domenico",
  "Domenicopaolo",
  "Domiziano",
  "Donatello",
  "Donato",
  "Doriano",
  "Doroteo",
  "Duccio",
  "Duilio",
  "Durante",
  "Eberardo",
  "Eddo",
  "Eden",
  "Edilio",
  "Edipo",
  "Edmondo",
  "Edoardo",
  "Efisio",
  "Efrem",
  "Egeo",
  "Egidio",
  "Egisto",
  "Egon",
  "Elia",
  "Eliano",
  "Elidio",
  "Eligio",
  "Elio",
  "Eliodoro",
  "Eliseo",
  "Elmo",
  "Elogio",
  "Elpidio",
  "Elvezio",
  "Elvio",
  "Emanuele",
  "Emidio",
  "Emilio",
  "Enea",
  "Eneko",
  "Ennio",
  "Enrico",
  "Enzo",
  "Eraclio",
  "Eraldo",
  "Erasmo",
  "Erberto",
  "Ercolano",
  "Ercole",
  "Eridano",
  "Ermanno",
  "Ermenegildo",
  "Ermes",
  "Ermete",
  "Erminio",
  "Ernesto",
  "Espedito",
  "Estore",
  "Ettore",
  "Euclide",
  "Eufemio",
  "Eugenio",
  "Eulogio",
  "Eusebio",
  "Eustachio",
  "Evaristo",
  "Evasio",
  "Ezio",
  "Ezzelino",
  "Fabiano",
  "Fabio",
  "Fabiolo",
  "Fabrizio",
  "Fausto",
  "Fedele",
  "Federico",
  "Fedro",
  "Felice",
  "Feliciano",
  "Ferdinando",
  "Fermo",
  "Fernando",
  "Ferruccio",
  "Festo",
  "Fidenzio",
  "Filadelfo",
  "Filiberto",
  "Filippo",
  "Fineo",
  "Fiorenzo",
  "Fiorino",
  "Firmino",
  "Flaminio",
  "Flaviano",
  "Flavio",
  "Floriano",
  "Folco",
  "Fortunato",
  "Fosco",
  "Francesco",
  "Franco",
  "Frediano",
  "Fulgenzio",
  "Fulvio",
  "Furio",
  "Fusco",
  "Gabino",
  "Gabriele",
  "Gabriello",
  "Gaetano",
  "Gagliardo",
  "Gaio",
  "Galdino",
  "Galeazzo",
  "Galileo",
  "Galliano",
  "Gallo",
  "Gandolfo",
  "Garibaldo",
  "Gaspare",
  "Gastone",
  "Gaudenzio",
  "Gavino",
  "Gedeone",
  "Gelasio",
  "Gelindo",
  "Gelmino",
  "Gelsomino",
  "Geminiano",
  "Generoso",
  "Genesio",
  "Gennaro",
  "Gentile",
  "Genziano",
  "Gerardo",
  "Gerasimo",
  "Geremia",
  "Germano",
  "Gerolamo",
  "Geronimo",
  "Gervasio",
  "Gesualdo",
  "Getulio",
  "Ghino",
  "Giacinto",
  "Giacobbe",
  "Giacomo",
  "Giambattista",
  "Giampaolo",
  "Giampiero",
  "Gian",
  "Gianantonio",
  "Giancarlo",
  "Giandomenico",
  "Gianfranco",
  "Gianluca",
  "Gianluigi",
  "Gianmarco",
  "Gianmario",
  "Gianmaria",
  "Gianni",
  "Giannino",
  "Giasone",
  "Gigliolo",
  "Gilberto",
  "Gildo",
  "Gino",
  "Gioacchino",
  "Giobbe",
  "Giocondo",
  "Gioele",
  "Giona",
  "Gionata",
  "Giordano",
  "Giorgio",
  "Giosafat",
  "Giosuè",
  "Giotto",
  "Giovanni",
  "Giovannino",
  "Giove",
  "Gioventino",
  "Girardo",
  "Girolamo",
  "Giuliano",
  "Giulio",
  "Giuliobello",
  "Giuseppe",
  "Giuseppino",
  "Giustino",
  "Giusto",
  "Glauco",
  "Glicerio",
  "Goffredo",
  "Golia",
  "Gonerio",
  "Gonzaga",
  "Gordiano",
  "Gottardo",
  "Graziano",
  "Gregorio",
  "Grimaldo",
  "Gualberto",
  "Gualfredo",
  "Gualtiero",
  "Guarino",
  "Guelfo",
  "Guido",
  "Guidobaldo",
  "Guglielmo",
  "Gustavo",
  "Icilio",
  "Idilio",
  "Iginio",
  "Igino",
  "Ignazio",
  "Ilario",
  "Ildebrando",
  "Ildefonso",
  "Ildo",
  "Immacolato",
  "Indro",
  "Innocente",
  "Innocenzo",
  "Ippocrate",
  "Ippolito",
  "Ireneo",
  "Irnerio",
  "Isacco",
  "Isaia",
  "Isidoro",
  "Ismaele",
  "Italo",
  "Ivano",
  "Ivanoe",
  "Ivo",
  "Ivone",
  "Jacopo",
  "Jago",
  "Jarno",
  "Kevin",
  "Lamberto",
  "Lando",
  "Landolfo",
  "Lanfranco",
  "Lapo",
  "Lazzaro",
  "Leandro",
  "Leo",
  "Leonardo",
  "Leoncino",
  "Leone",
  "Leonello",
  "Leonida",
  "Leopardo",
  "Leopoldo",
  "Letterio",
  "Liberato",
  "Libero",
  "Liborio",
  "Licinio",
  "Lido",
  "Lieto",
  "Lino",
  "Lionello",
  "Livio",
  "Lodovico",
  "Loreno",
  "Lorenzo",
  "Loris",
  "Luca",
  "Luciano",
  "Lucifero",
  "Lucilio",
  "Lucio",
  "Ludovico",
  "Luigi",
  "Luigino",
  "Macario",
  "Macedonio",
  "Mafaldo",
  "Maggiorino",
  "Malatesta",
  "Manasse",
  "Manfredo",
  "Manlio",
  "Mansueto",
  "Manuel",
  "Manuele",
  "Marcantonio",
  "Marcello",
  "Marciano",
  "Marco",
  "Mariano",
  "Marino",
  "Mario",
  "Marone",
  "Marteo",
  "Martino",
  "Marzio",
  "Massimiliano",
  "Massimo",
  "Mastino",
  "Matteo",
  "Mattia",
  "Mauro",
  "Maurizio",
  "Medardo",
  "Medoro",
  "Melchiorre",
  "Melezio",
  "Menelao",
  "Mercurio",
  "Metello",
  "Metodio",
  "Michelangelo",
  "Michele",
  "Mico",
  "Milziade",
  "Mino",
  "Mirco",
  "Mirko",
  "Miro",
  "Modesto",
  "Monaldo",
  "Moreno",
  "Mosè",
  "Muzio",
  "Nabil",
  "Nadir",
  "Nando",
  "Nanni",
  "Napoleone",
  "Narciso",
  "Nardo",
  "Natale",
  "Natalino",
  "Nazario",
  "Nazzareno",
  "Nazzaro",
  "Nearco",
  "Nedo",
  "Neo",
  "Nereo",
  "Neri",
  "Nerino",
  "Nerio",
  "Nerone",
  "Nestore",
  "Nicandro",
  "Niceforo",
  "Niceto",
  "Nico",
  "Nicodemo",
  "Nicola",
  "Nicolò",
  "Nilo",
  "Nino",
  "Noah",
  "Norberto",
  "Noris",
  "Novello",
  "Nubio",
  "Numa",
  "Nunzio",
  "Oddo",
  "Oderico",
  "Odino",
  "Odoacre",
  "Odoardo",
  "Olaf",
  "Olcese",
  "Olimpio",
  "Olindo",
  "Oliver",
  "Oliverio",
  "Oliviero",
  "Omar",
  "Omero",
  "Onesto",
  "Onofrio",
  "Onorato",
  "Onorio",
  "Orazio",
  "Orfeo",
  "Orio",
  "Orlando",
  "Oronzo",
  "Orso",
  "Ortenso",
  "Oscar",
  "Osvaldo",
  "Otello",
  "Ottaviano",
  "Ottavio",
  "Ottone",
  "Ovidio",
  "Ozanam",
  "Pacifico",
  "Pacomio",
  "Palmiro",
  "Pancrazio",
  "Pandolfo",
  "Panfilo",
  "Pantaleo",
  "Pantaleone",
  "Paolo",
  "Paride",
  "Pasquale",
  "Pasqualino",
  "Paterno",
  "Patrizio",
  "Patroclo",
  "Pellegrino",
  "Pericle",
  "Perseo",
  "Petronio",
  "Pier",
  "Pierangelo",
  "Pierantonio",
  "Piercarlo",
  "Pierfrancesco",
  "Piergiorgio",
  "Pierluigi",
  "Piermarco",
  "Piermaria",
  "Piero",
  "Pietro",
  "Pio",
  "Piramo",
  "Pirro",
  "Pisano",
  "Placido",
  "Platone",
  "Plinio",
  "Policarpo",
  "Polidoro",
  "Pompeo",
  "Pomponio",
  "Ponziano",
  "Ponzio",
  "Porfirio",
  "Prassede",
  "Priamo",
  "Primo",
  "Prisco",
  "Procopio",
  "Prospero",
  "Protasio",
  "Proteo",
  "Prudenzio",
  "Publio",
  "Pupo",
  "Quarto",
  "Quinto",
  "Quirico",
  "Quirino",
  "Radames",
  "Radolfo",
  "Raffaele",
  "Raffaello",
  "Raimondo",
  "Rainero",
  "Ramiro",
  "Raniero",
  "Ranuccio",
  "Raoul",
  "Redento",
  "Reginaldo",
  "Regolo",
  "Remigio",
  "Remo",
  "Renato",
  "Renzo",
  "Respicio",
  "Riccardo",
  "Rinaldo",
  "Rino",
  "Riziero",
  "Roberto",
  "Rocco",
  "Rodolfo",
  "Rodrigo",
  "Rolando",
  "Romano",
  "Romeo",
  "Romoaldo",
  "Romolo",
  "Romualdo",
  "Rosario",
  "Rosolino",
  "Rossano",
  "Rubaldo",
  "Rubens",
  "Ruffino",
  "Ruffo",
  "Rufino",
  "Rufo",
  "Ruggero",
  "Ruggiero",
  "Sabatino",
  "Sabato",
  "Sabino",
  "Saffo",
  "Salomone",
  "Salvatore",
  "Salvo",
  "Samuele",
  "Sandro",
  "Sansone",
  "Sante",
  "Santino",
  "Santo",
  "Saturnino",
  "Saturno",
  "Saverio",
  "Savino",
  "Scipione",
  "Sebastiano",
  "Secondo",
  "Semiramide",
  "Sempronio",
  "Serafino",
  "Serapione",
  "Sergio",
  "Sertorio",
  "Servio",
  "Sesto",
  "Settimio",
  "Settimo",
  "Severiano",
  "Severino",
  "Severo",
  "Sigfrido",
  "Sigismondo",
  "Silvano",
  "Silverio",
  "Silvestro",
  "Silvio",
  "Simmaco",
  "Simone",
  "Sinibaldo",
  "Siro",
  "Sisto",
  "Socrate",
  "Sofocle",
  "Solone",
  "Spartaco",
  "Stanislao",
  "Stefano",
  "Stelio",
  "Taddeo",
  "Tancredi",
  "Tarcisio",
  "Tarquinio",
  "Tarsilio",
  "Tazio",
  "Telemaco",
  "Telesforo",
  "Temistocle",
  "Teobaldo",
  "Teodolfo",
  "Teodoro",
  "Teodosio",
  "Teofilo",
  "Terenzio",
  "Terzo",
  "Tesauro",
  "Teseo",
  "Tiberio",
  "Tiburzio",
  "Ticone",
  "Timoteo",
  "Tito",
  "Tiziano",
  "Tizio",
  "Tobia",
  "Tolomeo",
  "Tommaso",
  "Torquato",
  "Tosco",
  "Tranquillo",
  "Tristano",
  "Tulliano",
  "Tullio",
  "Turi",
  "Turiddu",
  "Ubaldo",
  "Uberto",
  "Ugo",
  "Ugolino",
  "Uguccione",
  "Ulberto",
  "Ulderico",
  "Ulisse",
  "Ulrico",
  "Ultimo",
  "Umberto",
  "Urbano",
  "Uriele",
  "Valdemaro",
  "Valdo",
  "Valente",
  "Valentino",
  "Valeriano",
  "Valerio",
  "Valfredo",
  "Valfrido",
  "Valter",
  "Varo",
  "Vasco",
  "Venanzio",
  "Venceslao",
  "Venerio",
  "Ventura",
  "Venusto",
  "Verano",
  "Verecondo",
  "Verulo",
  "Vespasiano",
  "Vettore",
  "Vico",
  "Vidone",
  "Vigilio",
  "Viliberto",
  "Vilfredo",
  "Vindice",
  "Vincenzo",
  "Vinicio",
  "Virgilio",
  "Virginio",
  "Virone",
  "Vitale",
  "Vitaliano",
  "Vito",
  "Vittore",
  "Vittorio",
  "Vivaldo",
  "Vladimiro",
  "Volfango",
  "Volturno",
  "Walter",
  "Werther",
  "William",
  "Xaver",
  "Zaccaria",
  "Zaccheo",
  "Zanobi",
  "Zefiro",
  "Zeno",
  "Zenobio",
  "Zenone",
  "Zoe",
  "Zoilo",
  "Zosimo",
  "Adone",
  "Agamennone",
  "Albertino",
  "Albizzo",
  "Albo",
  "Alceo",
  "Alcibiade",
  "Alcidio",
  "Alcido",
  "Alciso",
  "Aldemaro",
  "Aldemio",
  "Aldemiro",
  "Aldemo",
  "Ado",
  "Adolfino",
  "Adorando",
  "Adorato",
  "Adornino",
  "Adorno",
  "Adrasto",
  "Adreano",
  "Aduilio",
  "Aduino",
  "Aduo",
  "Affortunato",
  "Africano",
  "Africo",
  "Afro",
  "Afrodisio",
  "Agabio",
  "Agabito",
  "Agatocle",
  "Agatone",
  "Agazio",
  "Ageo",
  "Agesilao",
  "Aggeo",
  "Agide",
  "Agilulfo",
  "Agnello",
  "Agnesio",
  "Agnolo",
  "Agricolo",
  "Agrisio",
  "Aguinaldo",
  "Aicardo",
  "Aido",
  "Aimo",
  "Airaldo",
  "Aiuto",
  "Alaghiero",
  "Alamiro",
  "Alan",
  "Albanino",
  "Alberigo",
  "Alberino",
  "Albio",
  "Albionte",
  "Albizio",
  "Aldegardo",
  "Aldegondo",
  "Adelmo",
  "Aderito",
  "Adermo",
  "Adilio",
  "Adimaro",
  "Adimiro",
  "Adino",
  "Adinolfo",
  "Adio",
  "Adiuto",
  "Adiutore",
  "Admeto",
  "Abaco",
  "Abbondanzio",
  "Abbondazio",
  "Abdenago",
  "Abdon",
  "Abdone",
  "Abelardo",
  "Aberardo",
  "Abilio",
  "Abondio",
  "Abramino",
  "Accorso",
  "Achilla",
  "Achilleo",
  "Acilio",
  "Acquisto",
  "Acrisio",
  "Adalciso",
  "Adalgerio",
  "Adalindo",
  "Adalio",
  "Adamello",
  "Adamino",
  "Adastro",
  "Addamiano",
  "Addario",
  "Addiego",
  "Addolorato",
  "Addonizio",
  "Adelaido",
  "Adelasio",
  "Adelchio",
  "Adelco",
  "Adelelmo",
  "Adelfino",
  "Adelfio",
  "Adelindo",
  "Adelino"
];

export const IT_FEMALE_NAMES = [
  "Abriana",
  "Accursia",
  "Adele",
  "Adelina",
  "Adriana",
  "Agnese",
  "Agnola",
  "Alaia",
  "Aldina",
  "Alessa",
  "Alessandra",
  "Alessia",
  "Allegra",
  "Alice",
  "Amadea",
  "Amadora",
  "Amalia",
  "Amalfi",
  "Amara",
  "Amata",
  "Ambra",
  "Amelia",
  "Amelita",
  "Amore",
  "Andrea",
  "Angela",
  "Angelica",
  "Angelina",
  "Anita",
  "Anna",
  "Annabella",
  "Annalisa",
  "Annina",
  "Annunciata",
  "Antonella",
  "Antonia",
  "Antonietta",
  "Aria",
  "Arianna",
  "Ariah",
  "Arlena",
  "Armani",
  "Aurora",
  "Aurelia",
  "Azzurra",
  "Bambi",
  "Bambina",
  "Battista",
  "Beatrice",
  "Bella",
  "Bellanca",
  "Benedetta",
  "Bettina",
  "Bianca",
  "Bice",
  "Bionda",
  "Blancha",
  "Bonfilia",
  "Bria",
  "Brunetta",
  "Caldonia",
  "Calogera",
  "Camilla",
  "Capri",
  "Capriana",
  "Cara",
  "Carina",
  "Carlina",
  "Carlota",
  "Carlotta",
  "Carmine",
  "Caterina",
  "Cecilia",
  "Celeste",
  "Chiara",
  "Ciandra",
  "Ciana",
  "Cianna",
  "Cielo",
  "Cienna",
  "Clara",
  "Clarisse",
  "Claudia",
  "Chloe",
  "Dafne",
  "Danila",
  "Daniella",
  "Diana",
  "Diletta",
  "Domenica",
  "Donatella",
  "Donna",
  "Donisha",
  "Drusilla",
  "Dulce",
  "Edoardo",
  "Elena",
  "Eleonora",
  "Elettra",
  "Elisa",
  "Elisabetta",
  "Eloisa",
  "Elvina",
  "Emilia",
  "Emily",
  "Emma",
  "Enea",
  "Erminia",
  "Eva",
  "Fabiana",
  "Felicia",
  "Felice",
  "Fernanda",
  "Fia",
  "Fiammetta",
  "Fina",
  "Fiore",
  "Fiorella",
  "Fioretta",
  "Fiorenza",
  "Fiora",
  "Flavia",
  "Franca",
  "Francesca",
  "Francisca",
  "Gabriella",
  "Gaia",
  "Galilea",
  "Gaudenzia",
  "Gelsomina",
  "Gemma",
  "Ghita",
  "Gia",
  "Giada",
  "Giana",
  "Gianella",
  "Gianna",
  "Ginetta",
  "Ginevra",
  "Gioconda",
  "Gioia",
  "Gioiella",
  "Giorgia",
  "Giovanna",
  "Giavanna",
  "Giulia",
  "Giuliana",
  "Giulianna",
  "Giulietta",
  "Giuseppina",
  "Giustina",
  "Grazia",
  "Greta",
  "Guida",
  "Honora",
  "Ilaria",
  "Isabel",
  "Isabella",
  "Isabelle",
  "Jiana",
  "Jovanne",
  "Julia",
  "Kara",
  "Kierra",
  "Lara",
  "Lavinia",
  "Lelia",
  "Leontina",
  "Leonora",
  "Leta",
  "Letizia",
  "Lia",
  "Lida",
  "Lieta",
  "Lilia",
  "Liliana",
  "Lilla",
  "Linda",
  "Livia",
  "Lorenza",
  "Loretta",
  "Lucia",
  "Luciana",
  "Ludovica",
  "Luisa",
  "Luna",
  "Lunetta",
  "Marcella",
  "Margherita",
  "Maria",
  "Mariella",
  "Marta",
  "Martina",
  "Marzia",
  "Matilde",
  "Melissa",
  "Mia",
  "Micola",
  "Milana",
  "Milania",
  "Mirabella",
  "Mirella",
  "Musetta",
  "Natalia",
  "Nella",
  "Nicola",
  "Nicole",
  "Nina",
  "Ninfa",
  "Noemi",
  "Nora",
  "Nunzia",
  "Ofelia",
  "Ombretta",
  "Oriana",
  "Ornella",
  "Orsola",
  "Ortensia",
  "Ottavia",
  "Palmina",
  "Pamina",
  "Paola",
  "Paolina",
  "Perla",
  "Pia",
  "Pierina",
  "Pippa",
  "Raffaella",
  "Rallegra",
  "Ravenna",
  "Renata",
  "Rita",
  "Roma",
  "Romina",
  "Romola",
  "Rosa",
  "Rosalia",
  "Rosella",
  "Rosetta",
  "Sara",
  "Saveria",
  "Senna",
  "Serafina",
  "Serena",
  "Serenella",
  "Sicily",
  "Sienna",
  "Siena",
  "Silvia",
  "Simona",
  "Ilaria",
  "Iolanda",
  "Irene",
  "Iris",
  "Irma",
  "Isabella",
  "Isotta",
  "Italia",
  "Ivana",
  "Ivonne",
  "Jessica",
  "Katia",
  "Lara",
  "Laura",
  "Lavinia",
  "Lea",
  "Leda",
  "Lena",
  "Letizia",
  "Lia",
  "Liana",
  "Lidia",
  "Liliana",
  "Linda",
  "Lisa",
  "Livia",
  "Liviana",
  "Lodovica",
  "Lolita",
  "Loredana",
  "Lorena",
  "Lorenza",
  "Loretta",
  "Luce",
  "Lucia",
  "Luciana",
  "Ludovica",
  "Luigina",
  "Luisa",
  "Luna",
  "Maddalena",
  "Mafalda",
  "Magda",
  "Mara",
  "Marcella",
  "Maria",
  "Marianna",
  "Mariangela",
  "Marica",
  "Marilena",
  "Marilù",
  "Marina",
  "Marinella",
  "Marisa",
  "Marta",
  "Martina",
  "Marzia",
  "Matilde",
  "Maura",
  "Melissa",
  "Michela",
  "Milena",
  "Mina",
  "Miranda",
  "Mirella",
  "Miriam",
  "Mirta",
  "Monica",
  "Nadia",
  "Nazzarena",
  "Nicoletta",
  "Nina",
  "Noemi",
  "Nora",
  "Norma",
  "Novella",
  "Nunzia",
  "Ofelia",
  "Olga",
  "Olimpia",
  "Oliva",
  "Olivia",
  "Ornella",
  "Orsola",
  "Ottavia",
  "Palma",
  "Palmira",
  "Paola",
  "Paolina",
  "Patrizia",
  "Perla",
  "Piera",
  "Pina",
  "Prisca",
  "Raffaella",
  "Rebecca",
  "Regina",
  "Renata",
  "Riccarda",
  "Rina",
  "Rita",
  "Roberta",
  "Romana",
  "Romina",
  "Rosa",
  "Rosalia",
  "Rosalinda",
  "Rosanna",
  "Rossana",
  "Rossella",
  "Sabrina",
  "Samanta",
  "Sandra",
  "Santina",
  "Sara",
  "Saveria",
  "Scilla",
  "Sebastiana",
  "Selvaggia",
  "Serafina",
  "Serena",
  "Sibilla",
  "Silvana",
  "Silvia",
  "Simonetta",
  "Sofia",
  "Giulia",
  "Aurora",
  "Ginevra",
  "Alice",
  "Emma",
  "Giorgia",
  "Greta",
  "Beatrice",
  "Vittoria",
  "Matilde",
  "Ludovica",
  "Anna",
  "Chiara",
  "Martina",
  "Sara",
  "Nicole",
  "Gaia",
  "Elisa",
  "Bianca",
  "Camilla",
  "Arianna",
  "Noemi",
  "Francesca",
  "Alessia",
  "Viola",
  "Eleonora",
  "Carlotta",
  "Rebecca",
  "Serena",
  "Elena",
  "Laura",
  "Valentina",
  "Federica",
  "Veronica",
  "Azzurra",
  "Benedetta",
  "Cristina",
  "Diana",
  "Eva",
  "Flavia",
  "Gabriella",
  "Irene",
  "Livia",
  "Maria",
  "Natalia",
  "Olivia",
  "Paola",
  "Roberta",
  "Silvia",
  "Teresa",
  "Umberta",
  "Valeria",
  "Zaira",
  "Adelaide",
  "Agata",
  "Alberta",
  "Alda",
  "Alessandra",
  "Allegra",
  "Amalia",
  "Ambra",
  "Anastasia",
  "Angelica",
  "Annabella",
  "Annalisa",
  "Antonella",
  "Antonia",
  "Asia",
  "Assunta",
  "Aurelia",
  "Barbara",
  "Bartolomea",
  "Basilia",
  "Battistina",
  "Beniamina",
  "Bernardetta",
  "Berta",
  "Bettina",
  "Bibiana",
  "Bruna",
  "Calogera",
  "Candida",
  "Carina",
  "Carla",
  "Carmela",
  "Carolina",
  "Casimira",
  "Catena",
  "Caterina",
  "Cecilia",
  "Celeste",
  "Celestina",
  "Cesarina",
  "Cinzia",
  "Clara",
  "Claudia",
  "Clelia",
  "Clementina",
  "Clotilde",
  "Concetta",
  "Consolata",
  "Cora",
  "Cordelia",
  "Cornelia",
  "Cosima",
  "Costanza",
  "Dalila",
  "Dalia",
  "Damiana",
  "Daniela",
  "Danila",
  "Daria",
  "Dea",
  "Debora",
  "Delia",
  "Delfina",
  "Desdemona",
  "Desideria",
  "Diamante",
  "Diletta",
  "Dina",
  "Dionisia",
  "Domenica",
  "Donata",
  "Donatella",
  "Dora",
  "Doriana",
  "Dorotea",
  "Drusiana",
  "Edda",
  "Edelberga",
  "Editta",
  "Edvige",
  "Egidia",
  "Egle",
  "Elda",
  "Elettra",
  "Eliana",
  "Elide",
  "Eligia",
  "Elina",
  "Elisabetta",
  "Ella",
  "Elodia",
  "Eloisa",
  "Elsa",
  "Elvira",
  "Elvia",
  "Ema",
  "Emanuela",
  "Emilia",
  "Emiliana",
  "Enrica",
  "Enza",
  "Eufemia",
  "Eugenia",
  "Eulalia",
  "Eurasia",
  "Eusapia",
  "Eusebia",
  "Evangelina",
  "Evelina",
  "Fabia",
  "Fabiana",
  "Fabiola",
  "Fara",
  "Fatima",
  "Fausta",
  "Faustina",
  "Febronia",
  "Fedora",
  "Fedra",
  "Felicita",
  "Fernanda",
  "Fiammetta",
  "Fidenzia",
  "Filomena",
  "Fiordaliso",
  "Fiore",
  "Fiorella",
  "Fiorenza",
  "Flaminia",
  "Flaviana",
  "Flora",
  "Floriana",
  "Florida",
  "Florinda",
  "Folco",
  "Fortunata",
  "Fosca",
  "Franca",
  "Fulvia",
  "Gaetana",
  "Galatea",
  "Gelsomina",
  "Gemma",
  "Genoveffa",
  "Germana",
  "Gherarda",
  "Ghita",
  "Giacinta",
  "Giada",
  "Gigliola",
  "Gilda",
  "Gina",
  "Gioacchina",
  "Gioconda",
  "Gioia",
  "Gisella",
  "Giuditta",
  "Giulitta",
  "Giuseppa",
  "Giuseppina",
  "Giustina",
  "Gloria",
  "Grazia",
  "Graziella",
  "Griselda",
  "Guendalina",
  "Guerina",
  "Ida",
  "Ifigenia",
  "Iginia",
  "Ilda",
  "Ildebranda",
  "Ildegonda",
  "Ileana",
  "Ilenia",
  "Ilia",
  "Immacolata",
  "Ines",
  "Iole",
  "Iolanda",
  "Ione",
  "Iride",
  "Irma",
  "Isa",
  "Iside",
  "Isotta",
  "Italia",
  "Ivana",
  "Ivonne",
  "Jacopa",
  "Jacopina",
  "Jone",
  "Jole",
  "Lamberta",
  "Landa",
  "Lauretta",
  "Lea",
  "Leda",
  "Lelia",
  "Lena",
  "Leonarda",
  "Leonida",
  "Leonilda",
  "Leontina",
  "Leopoldina",
  "Liana",
  "Liberata",
  "Liboria",
  "Lidia",
  "Liduvina",
  "Lilia",
  "Liliana",
  "Lisa",
  "Liviana",
  "Lodovica",
  "Lola",
  "Lolita",
  "Loredana",
  "Lorena",
  "Loriana",
  "Luana",
  "Luce",
  "Lucilla",
  "Lucrezia",
  "Luigia",
  "Luigina",
  "Luisella",
  "Macaria",
  "Maddalena",
  "Mafalda",
  "Magda",
  "Maida",
  "Maira",
  "Malvina",
  "Manuela",
  "Mara",
  "Marcellina",
  "Mariangela",
  "Marica",
  "Mariella",
  "Marilena",
  "Marilù",
  "Marina",
  "Marinella",
  "Marisa",
  "Massima",
  "Massimiliana",
  "Matelda",
  "Maura",
  "Maurizia",
  "Melania",
  "Melissa",
  "Melita",
  "Menodora",
  "Michela",
  "Michelina",
  "Milena",
  "Milva",
  "Mina",
  "Minerva",
  "Miranda",
  "Mirella",
  "Miria",
  "Miriam",
  "Mirta",
  "Modesta",
  "Moira",
  "Monica",
  "Monna",
  "Morena",
  "Morgana",
  "Nadia",
  "Nadina",
  "Nalda",
  "Nanda",
  "Nanna",
  "Nannina",
  "Nara",
  "Narcisa",
  "Nazzarena",
  "Neda",
  "Nedda",
  "Neera",
  "Nelia",
  "Nella",
  "Nerea",
  "Nereide",
  "Nerina",
  "Nicla",
  "Nicola",
  "Nicoletta",
  "Nilde",
  "Ninetta",
  "Ninfa",
  "Nives",
  "Norberta",
  "Norina",
  "Norma",
  "Novella",
  "Nuccia",
  "Nuncia",
  "Odetta",
  "Odilia",
  "Ofelia",
  "Olga",
  "Olimpia",
  "Olinda",
  "Oliva",
  "Olivia",
  "Oliviera",
  "Orazia",
  "Orchidea",
  "Oriana",
  "Orietta",
  "Ornella",
  "Orsola",
  "Orsolina",
  "Ortensia",
  "Osanna",
  "Ottavia",
  "Ottilia",
  "Palmira",
  "Paolina",
  "Pasqua",
  "Pasqualina",
  "Patrizia",
  "PELLEGRINA",
  "Penelope",
  "Perla",
  "Petronilla",
  "Pia",
  "Piera",
  "Pierina",
  "Pina",
  "Placida",
  "Polissena",
  "Porzia",
  "Prassede",
  "Prima",
  "Primetta",
  "Primina",
  "Prisca",
  "Priscilla",
  "Prospera",
  "Proserpina",
  "Provvidenza",
  "Prudenza",
  "Quintilia",
  "Quintina",
  "Quirina",
  "Rachele",
  "Raffaella",
  "Raissa",
  "Rebecca",
  "Regina",
  "Remigia",
  "Renata",
  "Riccarda",
  "Rina",
  "Rita",
  "Roberta",
  "Rocca",
  "Rolanda",
  "Romana",
  "Romilda",
  "Romina",
  "Romola",
  "Romualda",
  "Rosa",
  "Rosalia",
  "Rosalinda",
  "Rosamunda",
  "Rosanna",
  "Rosaria",
  "Rosetta",
  "Rosina",
  "Rosita",
  "Rossana",
  "Rossella",
  "Rufina",
  "Sabina",
  "Sabrina",
  "Samanta",
  "Samona",
  "Sandra",
  "Santina",
  "Saffo",
  "Sara",
  "Savina",
  "Scolastica",
  "Seconda",
  "Secondina",
  "Sefora",
  "Selvaggia",
  "Semiramide",
  "Serafina",
  "Serena",
  "Severa",
  "Severina",
  "Sibilla",
  "Sidonia",
  "Silvana",
  "Silveria",
  "Simona",
  "Siria",
  "Solana",
  "Solange",
  "Soledad",
  "Sonia",
  "Speranza",
  "Stefania",
  "Stella",
  "Susanna",
  "Sveva",
  "Taisia",
  "Tamara",
  "Tara",
  "Tarsilla",
  "Tazia",
  "Tea",
  "Tecla",
  "Teodata",
  "Teodolinda",
  "Teodora",
  "Teodosia",
  "Teresina",
  "Tersilla",
  "Tiberia",
  "Tiziana",
  "Tolomea",
  "Tosca",
  "Tranquilla",
  "Tristana",
  "Ubalda",
  "Ubertina",
  "Uga",
  "Ulderica",
  "Ulfa",
  "Uliva",
  "Umberta",
  "Umile",
  "Unna",
  "Urbana",
  "Valeriana",
  "Vanda",
  "Vanessa",
  "Vanna",
  "Velia",
  "Venanzia",
  "Venera",
  "Veneranda",
  "Vera",
  "Verena",
  "Veriana",
  "Veronica",
  "Vilma",
  "Vincenza",
  "Vincenzina",
  "Viola",
  "Violante",
  "Virginia",
  "Viridiana",
  "Visia",
  "Vita",
  "Vitalba",
  "Vitalia",
  "Vitaliana",
  "Vivalda",
  "Viviana",
  "Zama",
  "Zita",
  "Abaco",
  "Abbondanzio",
  "Abbondazio",
  "Abdenago",
  "Abdon",
  "Abdone",
  "Abelardo",
  "Aberardo",
  "Abilio",
  "Abondio",
  "Abramino",
  "Accorso",
  "Achilla",
  "Achilleo",
  "Acilio",
  "Acquisto",
  "Acrisio",
  "Adalciso",
  "Adalgerio",
  "Adalindo",
  "Adalio",
  "Adamello",
  "Adamino",
  "Adastro",
  "Addamiano",
  "Addario",
  "Addiego",
  "Addolorato",
  "Addonizio",
  "Adelaido",
  "Adelasio",
  "Adelchio",
  "Adelco",
  "Adelelmo",
  "Adelfino",
  "Adelfio",
  "Adelindo",
  "Adelino",
  "Adelmo",
  "Aderito",
  "Adermo",
  "Adilio",
  "Adimaro",
  "Adimiro",
  "Adino",
  "Adinolfo",
  "Adio",
  "Adiuto",
  "Adiutore",
  "Admeto",
  "Adone",
  "Adorando",
  "Adorato",
  "Adornino",
  "Adorno",
  "Adrasto",
  "Adreano",
  "Aduilio",
  "Aduino",
  "Aduo",
  "Affortunato",
  "Africano",
  "Africo",
  "Afro",
  "Afrodisio",
  "Agabio",
  "Agabito",
  "Agamennone",
  "Agatocle",
  "Agatone",
  "Agazio",
  "Ageo",
  "Agesilao",
  "Aggeo",
  "Agide",
  "Agilulfo",
  "Agnello",
  "Agnesio",
  "Agnolo",
  "Agricolo",
  "Agrisio",
  "Aguinaldo",
  "Aicardo",
  "Aido",
  "Aimo",
  "Airaldo",
  "Aiuto",
  "Alaghiero",
  "Alamiro",
  "Alan",
  "Albanino",
  "Alberigo",
  "Alberino",
  "Albertino",
  "Albio",
  "Albionte",
  "Albizio",
  "Albizzo",
  "Albo",
  "Alceo",
  "Alcibiade",
  "Alcidio",
  "Alcido",
  "Alciso",
  "Aldemaro",
  "Aldemio",
  "Aldemiro",
  "Aldemo",
  "Aldegardo",
  "Aldegondo",
  "Ado",
  "Adolfino",
  "Adalgisa",
  "Adalberta",
  "Adalberga",
  "Adela",
  "Adelasia",
  "Adelgisa",
  "Adelinda",
  "Adelma",
  "Adrietta",
  "Afra",
  "Agape",
  "Agatina",
  "Agnesina",
  "Aida",
  "Albina",
  "Alcina",
  "Alda",
  "Alida",
  "Alina",
  "Alma",
  "Altea",
  "Amalasunta",
  "Amalberga",
  "Amanda",
  "Ambra",
  "Ambrosina",
  "Amelia",
  "Amina",
  "Anatilde",
  "Ancilla",
  "Andromeda",
  "Angela",
  "Angelica",
  "Angelina",
  "Anita",
  "Anja",
  "Anna",
  "Annamaria",
  "Annunziata",
  "Antea",
  "Antera",
  "Antinisca",
  "Antonia",
  "Antonietta",
  "Apollina",
  "Apollonia",
  "Appia",
  "Aradia",
  "Arcangela",
  "Arda",
  "Ardita",
  "Argelia",
  "Argentina",
  "Aria",
  "Arianna",
  "Ariel",
  "Artemia",
  "Artemisia",
  "Artura",
  "Ascania",
  "Asia",
  "Asella",
  "Assunta",
  "Astrid",
  "Atanasia",
  "Atena",
  "Attilia",
  "Augusta",
  "Aura",
  "Aurea",
  "Aureliana",
  "Aurelia"
]

export const IT_LAST_NAMES = [
  "Abate",
  "Accardi",
  "Adami",
  "Agostini",
  "Aiello",
  "Albertini",
  "Alessi",
  "Alfonsi",
  "Amato",
  "Amico",
  "D'Amico",
  "D'Angelo",
  "Antonelli",
  "Argento",
  "Arosio",
  "Barbieri",
  "Barone",
  "Basile",
  "Bellini",
  "Bello",
  "Bernardi",
  "Bianchi",
  "Bianco",
  "Biondi",
  "Bongiorno",
  "Brambilla",
  "Bruno",
  "Calabrò",
  "Calabrese",
  "Campana",
  "Cantù",
  "Caputo",
  "Carbone",
  "Cardinale",
  "Carli",
  "Caruso",
  "Castelli",
  "Cattaneo",
  "Cavalli",
  "Cecchini",
  "Cherubini",
  "Chiesa",
  "Cocco",
  "Colombo",
  "Conte",
  "Conti",
  "Coppola",
  "Corona",
  "Costa",
  "Costantini",
  "Cozzi",
  "Cremonesi",
  "Crispi",
  "D'Agostino",
  "D'Alessandro",
  "D'Amato",
  "D'Andrea",
  "De Angelis",
  "De Falco",
  "De Filippis",
  "De Laurentiis",
  "De Luca",
  "De Lucia",
  "De Marco",
  "De Martino",
  "De Palma",
  "De Rosa",
  "De Santis",
  "De Simone",
  "Di Biagio",
  "Di Carlo",
  "Di Francesco",
  "Di Giovanni",
  "Di Gregorio",
  "Di Lorenzo",
  "Di Marco",
  "Di Maria",
  "Di Mario",
  "Di Mauro",
  "Di Napoli",
  "Di Nardo",
  "Di Pietro",
  "Di Stefano",
  "Donati",
  "Esposito",
  "Fabbri",
  "Farina",
  "Ferrara",
  "Ferrari",
  "Ferraro",
  "Ferretti",
  "Ferri",
  "Ferro",
  "Festa",
  "Filippi",
  "Fiore",
  "Fiorillo",
  "Fontana",
  "Forte",
  "Franchi",
  "Franco",
  "Fumagalli",
  "Fusco",
  "Gagliardi",
  "Galli",
  "Gallo",
  "Gambino",
  "Gatti",
  "Gentile",
  "Giordano",
  "Giorgi",
  "Giovannini",
  "Giuliani",
  "Grassi",
  "Grasso",
  "Greco",
  "Guerra",
  "Guerriero",
  "Iannone",
  "Iezzo",
  "Iovino",
  "Izzo",
  "La Barbera",
  "La Greca",
  "La Rocca",
  "La Russa",
  "Lamberti",
  "Lanza",
  "Leone",
  "Leonetti",
  "Li",
  "Lo Bianco",
  "Lo Duca",
  "Lo Faro",
  "Lo Monaco",
  "Lo Presti",
  "Lo Russo",
  "Lombardi",
  "Lombardo",
  "Longo",
  "Lorenzo",
  "Lucchese",
  "Macaluso",
  "Maggio",
  "Magnani",
  "Mancini",
  "Mancuso",
  "Manfrin",
  "Manfredi",
  "Marchesi",
  "Marchetti",
  "Marchi",
  "Marchionne",
  "Mariani",
  "Marino",
  "Mariotti",
  "Martini",
  "Martino",
  "Martorana",
  "Marzano",
  "Massa",
  "Massaro",
  "Mazza",
  "Mazzanti",
  "Mazzini",
  "Meloni",
  "Messina",
  "Mezzanotte",
  "Milano",
  "Montanari",
  "Monti",
  "Morelli",
  "Moretti",
  "Morgante",
  "Moro",
  "Morosini",
  "Moschella",
  "Motta",
  "Murgia",
  "Nardi",
  "Neri",
  "Nicchi",
  "Nicoletti",
  "Nicosia",
  "Nobile",
  "Notaro",
  "Orlando",
  "Orsini",
  "Pace",
  "Pagani",
  "Pagano",
  "Palmieri",
  "Palumbo",
  "Panza",
  "Paoletti",
  "Paolucci",
  "Parisi",
  "Pasquale",
  "Pellegrini",
  "Pellegrino",
  "Pelligra",
  "Pepe",
  "Perrone",
  "Petrucci",
  "Piana",
  "Piazza",
  "Piccoli",
  "Pinto",
  "Pirlo",
  "Pisani",
  "Pisano",
  "Pugliese",
  "Quagliarella",
  "Raso",
  "Ricci",
  "Rinaldi",
  "Riva",
  "Rizzo",
  "Rocca",
  "Romano",
  "Rosati",
  "Rossetti",
  "Rossi",
  "Rosso",
  "Rotondo",
  "Russo",
  "Sala",
  "Salerno",
  "Salvi",
  "Santini",
  "Santoro",
  "Sartori",
  "Sassi",
  "Saviano",
  "Scala",
  "Scavo",
  "Schiavo",
  "Schiavone",
  "Sciacca",
  "Serra",
  "Siciliano",
  "Silvestri",
  "Sorrentino",
  "Spada",
  "Tavano",
  "Tedesco",
  "Testa",
  "Totti",
  "Valentini",
  "Valli",
  "Negri",
  "Ferretti",
  "Montanari",
  "Donati",
  "Pellegrini",
  "Pugliese",
  "Palmieri",
  "D'Amico",
  "Bernardi",
  "Martino",
  "Fiore",
  "De Angelis",
  "Damico",
  "Ferri",
  "Barone",
  "Serra",
  "Bellini",
  "Sanna",
  "Riva",
  "Milani",
  "Pagano",
  "D'Agostino",
  "Amato",
  "Mariani",
  "Coppola",
  "Marchetti",
  "Sala",
  "Gatti",
  "Guerra",
  "Battaglia",
  "Palumbo",
  "Schiavone",
  "D'Antonio",
  "Basile",
  "Vitale",
  "Parisi",
  "Donà",
  "Rossetti",
  "Costantini",
  "D'Ambrogio",
  "Fabbri",
  "D'Angelo",
  "Mazza",
  "Sorrentino",
  "Pellegrino",
  "Carbone",
  "Martinelli",
  "Galli",
  "Orlando",
  "Piras",
  "Villa",
  "Conte",
  "Grasso",
  "Morelli",
  "De Santis",
  "D'Elia",
  "Testa",
  "Gentile",
  "Basso",
  "Neri",
  "Benedetti",
  "Cattaneo",
  "De Rosa",
  "Franco",
  "Marchese",
  "Messina",
  "Farina",
  "Valentini",
  "Monti",
  "Longo",
  "Leoni",
  "Cozzi",
  "Silvestri",
  "Ferrara",
  "Bianco",
  "Marini",
  "Santoro",
  "Rinaldi",
  "Barbieri",
  "Martini",
  "Caruso",
  "Leone",
  "D'Anna",
  "Lazzari",
  "Esposito",
  "Rossi",
  "Russo",
  "Ferrari",
  "Bianchi",
  "Romano",
  "Colombo",
  "Ricci",
  "Marino",
  "Greco",
  "Bruno",
  "Gallo",
  "Conti",
  "De Luca",
  "Mancini",
  "Costa",
  "Giordano",
  "Rizzo",
  "Lombardi",
  "Moretti",
  "Barone",
  "D'Alessandro",
  "Albertini",
  "Alfonsi",
  "Amore",
  "Ancona",
  "Andreotti",
  "Antonucci",
  "Argento",
  "Arturi",
  "Aversa",
  "Baldi",
  "Baldovino",
  "Bandini",
  "Barilla",
  "Bellomo",
  "Bertinelli",
  "Biagi",
  "Biondi",
  "Bonacci",
  "Bongiorno",
  "Rossi",
  "Russo",
  "Ferrari",
  "Esposito",
  "Bianchi",
  "Romano",
  "Colombo",
  "Ricci",
  "Marino",
  "Greco",
  "Bruno",
  "Gallo",
  "Conti",
  "De Luca",
  "Mancini",
  "Costa",
  "Giordano",
  "Rizzo",
  "Lombardi",
  "Moretti",
  "Barbieri",
  "Fontana",
  "Santoro",
  "Mariani",
  "Rinaldi",
  "Caruso",
  "Ferrara",
  "Galli",
  "Marini",
  "Leone",
  "Longo",
  "Gentile",
  "Martinelli",
  "Vitale",
  "Lombardo",
  "Serra",
  "Coppola",
  "De Santis",
  "D'Amico",
  "Martini",
  "Bianco",
  "Gatti",
  "Pellegrini",
  "Farina",
  "Villa",
  "Conte",
  "Ferraro",
  "Marchetti",
  "Riva",
  "Grassi",
  "Parisi",
  "De Angelis",
  "Morelli",
  "D'Angelo",
  "Silvestri",
  "Carbone",
  "Monti",
  "Fabbri",
  "Testa",
  "Amato",
  "Bernardi",
  "Sanna",
  "Cattaneo",
  "Basile",
  "Pagano",
  "Cozzi",
  "D'Agostino",
  "Neri",
  "Mazza",
  "Messina",
  "Sala",
  "Sorrentino",
  "Piras",
  "De Rosa",
  "Benedetti",
  "Donati",
  "Palmieri",
  "Orlando",
  "Pugliese",
  "Guerra",
  "Ferri",
  "Bellini",
  "Franco",
  "D'Antonio",
  "Milani",
  "Costantini",
  "Barone",
  "Palumbo",
  "Battaglia",
  "Schiavone",
  "D'Elia",
  "Rossetti",
  "Marchese",
  "Valentini",
  "Basso",
  "Lazzari",
  "D'Anna",
  "Donà",
  "Ferretti",
  "Montanari",
  "Negri",
  "Pellegrino",
  "Damico",
  "D'Ambrogio",
  "Abate",
  "Accardi",
  "Adami",
  "Agostini",
  "Aiello",
  "Albertini",
  "Alessi",
  "Alfonsi",
  "Amico",
  "Antonelli",
  "Argento",
  "Arosio",
  "Bellini",
  "Bello",
  "Biondi",
  "Bongiorno",
  "Brambilla",
  "Calabrò",
  "Calabrese",
  "Campana",
  "Cantù",
  "Caputo",
  "Cardinale",
  "Carli",
  "Castelli",
  "Cavalli",
  "Cecchini",
  "Cherubini",
  "Chiesa",
  "Cocco",
  "Corona",
  "Costantini",
  "Cremonesi",
  "Crispi",
  "D'Alessandro",
  "D'Amato",
  "D'Andrea",
  "De Falco",
  "De Filippis",
  "De Laurentiis",
  "De Lucia",
  "De Marco",
  "De Martino",
  "De Palma",
  "De Simone",
  "Di Biagio",
  "Di Carlo",
  "Di Francesco",
  "Di Giovanni",
  "Di Gregorio",
  "Di Lorenzo",
  "Di Marco",
  "Di Maria",
  "Di Mario",
  "Di Mauro",
  "Di Napoli",
  "Di Nardo",
  "Di Pietro",
  "Di Stefano",
  "Festa",
  "Filippi",
  "Fiore",
  "Fiorillo",
  "Forte",
  "Franchi",
  "Fumagalli",
  "Fusco",
  "Gagliardi",
  "Gambino",
  "Giorgi",
  "Giovannini",
  "Giuliani",
  "Grasso",
  "Guerriero",
  "Iannone",
  "Iezzo",
  "Iovino",
  "Izzo",
  "La Barbera",
  "La Greca",
  "La Rocca",
  "La Russa",
  "Lamberti",
  "Lanza",
  "Leonetti",
  "Li",
  "Lo Bianco",
  "Lo Duca",
  "Lo Faro",
  "Lo Monaco",
  "Lo Presti",
  "Lo Russo",
  "Lorenzo",
  "Lucchese",
  "Macaluso",
  "Maggio",
  "Magnani",
  "Mancuso",
  "Manfrin",
  "Manfredi",
  "Marchesi",
  "Marchi",
  "Marchionne",
  "Mariotti",
  "Martorana",
  "Marzano",
  "Massa",
  "Massaro",
  "Mazzanti",
  "Mazzini",
  "Meloni",
  "Mezzanotte",
  "Milano",
  "Morgante",
  "Moro",
  "Morosini",
  "Moschella",
  "Motta",
  "Murgia",
  "Nardi",
  "Nicchi",
  "Nicoletti",
  "Nicosia",
  "Nobile",
  "Notaro",
  "Orsini",
  "Pace",
  "Pagani",
  "Paoletti",
  "Paolucci",
  "Pasquale",
  "Pelligra",
  "Pepe",
  "Perrone",
  "Petrucci",
  "Piana",
  "Piazza",
  "Piccoli",
  "Pinto",
  "Pirlo",
  "Pisani",
  "Pisano",
  "Quagliarella",
  "Raso",
  "Rocca",
  "Rosati",
  "Rotondo",
  "Salerno",
  "Salvi",
  "Santini",
  "Sartori",
  "Sassi",
  "Saviano",
  "Scala",
  "Scavo",
  "Schiavo",
  "Sciacca",
  "Siciliano",
  "Spada",
  "Tavano",
  "Tedesco",
  "Totti",
  "Valli",
  "Acqua",
  "Addis",
  "Agnelli",
  "Alberici",
  "Alberti",
  "Aldi",
  "Allegri",
  "Altoviti",
  "Amadori",
  "Amati",
  "Ambrosini",
  "Ancelotti",
  "Anelli",
  "Angeli",
  "Anselmi",
  "Antinori",
  "Antonini",
  "Aquila",
  "Arcangeli",
  "Arcidiacono",
  "Arduino",
  "Armani",
  "Arrivabene",
  "Azzopardi",
  "Bacci",
  "Baggio",
  "Baglioni",
  "Balbo",
  "Baldini",
  "Baldovini",
  "Balotelli",
  "Balsamo",
  "Baracca",
  "Barbaro",
  "Barberini",
  "Barbero",
  "Baresi",
  "Barilla",
  "Bartoli",
  "Bartolini",
  "Barzini",
  "Baschenis",
  "Bassani",
  "Bastoni",
  "Battistini",
  "Bazzi",
  "Beccaria",
  "Bellucci",
  "Belmondo",
  "Benetton",
  "Benigni",
  "Bentivoglio",
  "Benvenuti",
  "Berardi",
  "Berlinguer",
  "Berlusconi",
  "Bernini",
  "Berruti",
  "Bertinelli",
  "Bertolucci",
  "Bettini",
  "Biagi",
  "Bianchini",
  "Boccherini",
  "Bocci",
  "Boiardo",
  "Boldrini",
  "Bonanno",
  "Boncompagni",
  "Bonfiglio",
  "Bonomi",
  "Borghese",
  "Borgia",
  "Borromeo",
  "Borsellino",
  "Bosco",
  "Bossi",
  "Botticelli",
  "Braccini",
  "Bragadin",
  "Bramante",
  "Breda",
  "Bresciani",
  "Brivio",
  "Brocchi",
  "Brunelleschi",
  "Bruni",
  "Buffon",
  "Bugatti",
  "Bulgari",
  "Buonarroti",
  "Burlando",
  "Busoni",
  "Buzzi",
  "Caboto",
  "Cabrini",
  "Caccini",
  "Cadorna",
  "Cafasso",
  "Caffarelli",
  "Cairoli",
  "Calafiore",
  "Calamandrei",
  "Calenda",
  "Calvino",
  "Cambiaso",
  "Cammarata",
  "Campanella",
  "Campanini",
  "Campari",
  "Campi",
  "Campisi",
  "Canali",
  "Canaletto",
  "Canova",
  "Cantalamessa",
  "Capecchi",
  "Capello",
  "Capone",
  "Cappellini",
  "Capponi",
  "Capra",
  "Capriati",
  "Caracciolo",
  "Caravaggio",
  "Carboni",
  "Cardano",
  "Carducci",
  "Carissimi",
  "Carnera",
  "Carnevali",
  "Carracci",
  "Carrara",
  "Carraro",
  "Casadei",
  "Casagrande",
  "Casanova",
  "Casiraghi",
  "Cassano",
  "Castiglione",
  "Cavalcanti",
  "Cavallaro",
  "Cavalli-Sforza",
  "Cavour",
  "Celentano",
  "Cellini",
  "Cenci",
  "Cera",
  "Ceresa",
  "Cerutti",
  "Cervi",
  "Cesalpino",
  "Cesarini",
  "Cesaro",
  "Chiabrera",
  "Chiaramonti",
  "Chigi",
  "Cialdini",
  "Ciampi",
  "Ciano",
  "Cibrario",
  "Cicciolina",
  "Cignani",
  "Cimabue",
  "Cimarosa",
  "Cini",
  "Cipollini",
  "Cipriani",
  "Cirillo",
  "Cisneros",
  "Civitali",
  "Clementi",
  "Cocciante",
  "Colonna",
  "Columbro",
  "Comencini",
  "Comisso",
  "Consigli",
  "Consoli",
  "Contarini",
  "Cordero",
  "Corelli",
  "Corleone",
  "Corradi",
  "Corrado",
  "Correggio",
  "Corsi",
  "Corsini",
  "Corti",
  "Cortina",
  "Cossiga",
  "Cossutta",
  "Costamagna",
  "Costanzo",
  "Cotta",
  "Cottolengo",
  "Crivelli",
  "Croce",
  "Cuccinello",
  "Cucciolla",
  "Cucinotta",
  "Curcio",
  "Daddi",
  "Dalla",
  "Dallapiccola",
  "Dandolo",
  "D'Annunzio",
  "Dante",
  "Da Vinci",
  "De Bosis",
  "De Chirico",
  "De Filippo",
  "De Gasperi",
  "Deledda",
  "Delfino",
  "Della Robbia",
  "Delle Piane",
  "Del Piero",
  "Del Prete",
  "Del Vecchio",
  "De Mita",
  "De Sica",
  "Di Canio",
  "Di Caprio",
  "Di Centa",
  "Di Pietro",
  "Di Savoia",
  "Dolce",
  "Domenichini",
  "Donadoni",
  "Donatello",
  "Donizetti",
  "Doria",
  "Dossi",
  "Duse",
  "Eco",
  "Einaudi",
  "Elefante",
  "Evola",
  "Fabbroni",
  "Fabri",
  "Fabris",
  "Facchetti",
  "Farinelli",
  "Farnese",
  "Fattori",
  "Favara",
  "Federici",
  "Fellini",
  "Feltri",
  "Ferragamo",
  "Ferrante",
  "Ferreri",
  "Ferrero",
  "Ficino",
  "Filangieri",
  "Filippini",
  "Finzi",
  "Finzi-Contini",
  "Fioravanti",
  "Fiorentino",
  "Fiorucci",
  "Fisichella",
  "Fogazzaro",
  "Fogliano",
  "Fois",
  "Fonda",
  "Forlani",
  "Fornasari",
  "Foscolo",
  "Fossati",
  "Fracastoro",
  "Frattini",
  "Frigerio",
  "Frizzi",
  "Furlan",
  "Gabbana",
  "Gadda",
  "Gaffurio",
  "Gagliano",
  "Galante",
  "Galilei",
  "Galimberti",
  "Galvani",
  "Garibaldi",
  "Garofalo",
  "Garzoni",
  "Gasparri",
  "Gasperi",
  "Gattuso",
  "Geminiani",
  "Gentileschi",
  "Giacometti",
  "Gianni",
  "Giannini",
  "Gigli",
  "Ginzburg",
  "Gioberti",
  "Giolitti",
  "Giordani",
  "Giorgione",
  "Giotto",
  "Giovine",
  "Giraldi",
  "Girardengo",
  "Giugiaro",
  "Giusti",
  "Gobetti",
  "Goldoni",
  "Golia",
  "Gonzaga",
  "Goretti",
  "Gozzi",
  "Gozzoli",
  "Gramsci",
  "Gravina",
  "Graziani",
  "Gronchi",
  "Guarneri",
  "Gucci",
  "Guicciardini",
  "Guidi",
  "Iacocca",
  "Inzaghi",
  "Jacuzzi",
  "Jannacci",
  "Jotti",
  "Lama",
  "Lamborghini",
  "Lampedusa",
  "Lancia",
  "Landolfi",
  "Lanfranchi",
  "Lattuada",
  "Lauro",
  "Leopardi",
  "Levi",
  "Levi-Montalcini",
  "Lollobrigida",
  "Loren",
  "Lorenzetti",
  "Loria",
  "Lotti",
  "Lotto",
  "Lucciano",
  "Luchino",
  "Luciani",
  "Lulli",
  "Luria",
  "Luzzatti",
  "Macchiavelli",
  "Maderna",
  "Maestri",
  "Maffei",
  "Maggia",
  "Magliocco",
  "Magnani",
  "Magnifico",
  "Malaparte",
  "Maldini",
  "Malipiero",
  "Malpighi",
  "Mameli",
  "Manara",
  "Mancinelli",
  "Manin",
  "Manzoni",
  "Maradona",
  "Marcello",
  "Marenzio",
  "Marinetti",
  "Maritain",
  "Marrone",
  "Marsilio",
  "Martelli",
  "Masaccio",
  "Mascagni",
  "Mascheroni",
  "Maserati",
  "Masina",
  "Massari",
  "Mastelloni",
  "Mastroianni",
  "Matteotti",
  "Mattioli",
  "Mazzola",
  "Medici",
  "Menabrea",
  "Menotti",
  "Mercadante",
  "Mercalli",
  "Merisi",
  "Merzario",
  "Metastasio",
  "Michelangeli",
  "Michelangelo",
  "Micheli",
  "Mieli",
  "Minghetti",
  "Mirandola",
  "Modigliani",
  "Modugno",
  "Mogol",
  "Molinari",
  "Mondadori",
  "Mondrian",
  "Monicelli",
  "Montale",
  "Montanelli",
  "Monteverdi",
  "Montessori",
  "Monti",
  "Morandi",
  "Moravia",
  "Morricone",
  "Morselli",
  "Moschino",
  "Mussolini",
  "Muti",
  "Nannini",
  "Napoleone",
  "Napolitano",
  "Natta",
  "Nenni",
  "Nesta",
  "Nievo",
  "Nigro",
  "Nitti",
  "Nono",
  "Novaro",
  "Nuvolari",
  "Odescalchi",
  "Olivari",
  "Olivetti",
  "Orlandi",
  "Orwell",
  "Pacciardi",
  "Pacinotti",
  "Paganini",
  "Paglia",
  "Paisiello",
  "Paladino",
  "Palladio",
  "Pallavicino",
  "Palma",
  "Panatta",
  "Pandolfi",
  "Panerai",
  "Panetta",
  "Panizzi",
  "Pannella",
  "Panofsky",
  "Panzini",
  "Paoli",
  "Paolini",
  "Papadopulo",
  "Papini",
  "Pareto",
  "Parini",
  "Parise",
  "Parma",
  "Pasolini",
  "Pascoli",
  "Pavese",
  "Pazzi",
  "Pecci",
  "Pellico",
  "Pergolesi",
  "Pertini",
  "Peruzzi",
  "Petrarca",
  "Petrassi",
  "Petri",
  "Petroni",
  "Piacentini",
  "Pianigiani",
  "Piastri",
  "Piazzi",
  "Picabia",
  "Piccard",
  "Piccinni",
  "Piccolomini",
  "Pico",
  "Pininfarina",
  "Piola",
  "Piovani",
  "Pirandello",
  "Pirelli",
  "Pisanello",
  "Piscopo",
  "Pistoletto",
  "Pizzetti",
  "Pizzi",
  "Platini",
  "Poccianti",
  "Poggi",
  "Poggioli",
  "Pola",
  "Poleni",
  "Poliziano",
  "Pollaiuolo",
  "Polo",
  "Pomodoro",
  "Ponti",
  "Pontormo",
  "Ponzi",
  "Porpora",
  "Porta",
  "Prada",
  "Pratolini",
  "Preti",
  "Puccini",
  "Puddu",
  "Puglisi",
  "Pulci",
  "Quasimodo",
  "Racca",
  "Raffaello",
  "Raimondi",
  "Ramazzotti",
  "Rattazzi",
  "Rava",
  "Ravegnani",
  "Renzi",
  "Respighi",
  "Riccardi",
  "Ricasoli",
  "Ricolfi",
  "Rienzi",
  "Righi",
  "Rimini",
  "Risi",
  "Rivera",
  "Robbia",
  "Rocca",
  "Rodari",
  "Romagnoli",
  "Roncalli",
  "Rosellini",
  "Rosselli",
  "Rossini",
  "Rothschild",
  "Rovere",
  "Rovigo",
  "Rubbia",
  "Rubini",
  "Rucellai",
  "Ruffini",
  "Rugova",
  "Ruspoli",
  "Saba",
  "Sabatini",
  "Sacchi",
  "Sacco",
  "Salandra",
  "Salgari",
  "Salieri",
  "Salvini",
  "Salviati",
  "Salvemini",
  "Salvetti",
  "Salvini",
  "Sammartini",
  "Sanfelice",
  "Sangallo",
  "Sansovino",
  "Sant'Elia",
  "Santi",
  "Sanudo",
  "Saragat",
  "Sarfatti",
  "Sarti",
  "Sarto",
  "Sassetti",
  "Sassoli",
  "Savonarola",
  "Savoia",
  "Scabin",
  "Scafidi",
  "Scarlatti",
  "Scarpa",
  "Scarpitta",
  "Scerbanenco",
  "Sciascia",
  "Scirea",
  "Scola",
  "Scotti",
  "Segni",
  "Segre",
  "Seminara",
  "Serao",
  "Sforza",
  "Sgarbi",
  "Signorelli",
  "Signori",
  "Silone",
  "Simoni",
  "Soderini",
  "Soffici",
  "Solari",
  "Soldati",
  "Sonnino",
  "Sordi",
  "Sorella",
  "Soresina",
  "Sottsass",
  "Spadolini",
  "Spallanzani",
  "Spano",
  "Speri",
  "Spinelli",
  "Spinola",
  "Squarcione",
  "Stampa",
  "Stradivari",
  "Strozzi",
  "Tabacchi",
  "Taccola",
  "Tadini",
  "Tagliafico",
  "Taglioni",
  "Tammany",
  "Tancredi",
  "Tarantino",
  "Tarchiani",
  "Tarlati",
  "Tartaglia",
  "Tartini",
  "Tasso",
  "Tassoni",
  "Tenca",
  "Terzani",
  "Tiepolo",
  "Tintoretto",
  "Tiraboschi",
  "Tiziano",
  "Toaff",
  "Togliatti",
  "Tomasi",
  "Tomba",
  "Toninelli",
  "Torelli",
  "Tornatore",
  "Torricelli",
  "Torrigiani",
  "Toscanini",
  "Tosi",
  "Trapani",
  "Trapattoni",
  "Trilussa",
  "Troisi",
  "Trombetti",
  "Tupini",
  "Turati",
  "Turchi",
  "Uccello",
  "Ughi",
  "Ungaretti",
  "Vaccari",
  "Valenti",
  "Valerga",
  "Valerio",
  "Valla",
  "Valle",
  "Valletta",
  "Valli",
  "Vannucci",
  "Vantini",
  "Vasari",
  "Vassalli",
  "Vattimo",
  "Vecchi",
  "Velasco",
  "Veltri",
  "Venturi",
  "Verdi",
  "Verga",
  "Veronese",
  "Verri",
  "Verrocchio",
  "Vespucci",
  "Vialli",
  "Viani",
  "Vico",
  "Vigano",
  "Vignola",
  "Villani",
  "Villari",
  "Vinci",
  "Viola",
  "Visconti",
  "Vittorini",
  "Vivaldi",
  "Viviani",
  "Volpi",
  "Volta",
  "Volterra",
  "Zaccheroni",
  "Zanardelli",
  "Zanetti",
  "Zanichelli",
  "Zanussi",
  "Zappa",
  "Zeffirelli",
  "Zola"
]